import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import logo from '../assets/bgcm-logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about';
  const isServicesPage = location.pathname === '/services';
  const isFAQPage = location.pathname === '/faq';
  const isContactPage = location.pathname === '/contact';
  const hasTransparentHeader = isHomePage || isAboutPage || isServicesPage || isFAQPage || isContactPage;

  const toggle = () => setIsOpen(!isOpen);

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Base styles
  const styles = {
    header: {
      backgroundColor: hasTransparentHeader ? 'transparent' : '#fff',
      position: hasTransparentHeader ? 'absolute' : 'relative',
      width: '100%',
      zIndex: 1000,
      boxShadow: hasTransparentHeader ? 'none' : '0 2px 5px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Poppins, sans-serif',
    },
   
    brandContainer: {
      display: 'flex',
      alignItems: 'center',
      color: 'var(--color-primary)',
      textDecoration: 'none',
    },
    logo: {
      height: isMobile ? '90px' : '110px',
      width: 'auto',
      marginRight: isMobile ? '8px' : '15px',
    },
    companyTitle: {
      fontSize: isMobile ? '14px' : '18px',
      fontWeight: '600',
      color: hasTransparentHeader ? '#fff' : 'var(--color-primary)',
      whiteSpace: isMobile ? 'normal' : 'nowrap',
      lineHeight: '1.2',
      textShadow: hasTransparentHeader ? '2px 2px 4px rgba(0, 0, 0, 0.5)' : 'none',
    },

    toggler: {
      border: 'none',
      color: hasTransparentHeader ? '#fff' : '#06435f',
    },
    nav: {
      marginLeft: 'auto',
      textAlign: isMobile ? 'center' : 'left',
      width: isMobile ? '100%' : 'auto',
    },
    navItem: {
      display: isMobile ? 'block' : 'inline-block',
      textAlign: 'center',
    },
    navLink: {
      color: hasTransparentHeader ? '#fff' : '#06435f',
      padding: isMobile ? '8px 10px' : '10px 15px',
      position: 'relative',
      transition: 'color 0.3s ease',
      display: 'block',
      textAlign: isMobile ? 'center' : 'left',
      textShadow: hasTransparentHeader ? '1px 1px 2px rgba(0, 0, 0, 0.5)' : 'none',
    },
    navLinkHover: {
      color: hasTransparentHeader ? '#fff' : '#06435f',
    },
    navLinkAfter: {
      content: '""',
      position: 'absolute',
      bottom: '5px',
      left: isMobile ? '50%' : '15px',
      transform: isMobile ? 'translateX(-50%)' : 'none',
      width: '0',
      height: '2px',
      backgroundColor: hasTransparentHeader ? '#fff' : '#06435f',
      transition: 'width 0.3s ease',
    },
    navLinkHoverAfter: {
      width: isMobile ? '50%' : 'calc(100% - 30px)',
    },
    dropdownToggle: {
      color: '#06435f',
      padding: isMobile ? '8px 10px' : '10px 15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: isMobile ? 'center' : 'flex-start',
      width: '100%',
    },
    dropdownArrow: {
      marginLeft: '5px',

    },
    dropdownMenu: {
      backgroundColor: '#06435f',
      border: 'none',
      borderRadius: '5px',
      width: '100%',
    },
    dropdownItem: {
      color: '#000',

      padding: '10px 20px',
      transition: 'background-color 0.3s ease',
      width: '100%',
      textAlign: isMobile ? 'center' : 'left',
    },
    dropdownItemHover: {
      backgroundColor: '#06435f',
      color: 'white',
    },
    togglerIcon: {
      display: 'inline-block',
      width: '28px',
      height: '28px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '24px 24px',
      backgroundImage: hasTransparentHeader 
        ? "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='%23fff' stroke-width='2.5' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/></svg>\")"
        : "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='%2306435f' stroke-width='2.5' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/></svg>\")"
    },
    navbar: {
      backgroundColor: hasTransparentHeader ? 'transparent' : '#fff',
    }
  };
  return (
    <header style={styles.header}>
      <Navbar dark expand="md" style={styles.navbar}>
        <NavbarBrand tag={Link} to="/" style={styles.brandContainer}>
          <img
            src={logo}
            alt="BGCM Logo"
            loading="lazy"
            style={styles.logo}
          />
          <span style={styles.companyTitle}>
            Bill Gates Offshore Crew Manning
          </span>
        </NavbarBrand>
        <NavbarToggler
          onClick={toggle}
          style={styles.toggler}
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
        >
          <span style={styles.togglerIcon} />
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar>
          <Nav navbar style={styles.nav}>
          
            <NavItem style={styles.navItem}>
              <NavLink
                tag={Link}
                to="/"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                Home
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                tag={Link}
                to="/about"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                About
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>

            <NavItem style={styles.navItem}>
              <NavLink
                tag={Link}
                to="/services"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                Services
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                tag={Link}
                to="/faq"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                FAQ
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>
            <NavItem style={styles.navItem}>
              <NavLink
                tag={Link}
                to="/contact"
                style={styles.navLink}
                onMouseEnter={(e) => {
                  e.target.style.color = styles.navLinkHover.color;
                  e.target.style.setProperty(
                    '--after-width',
                    styles.navLinkHoverAfter.width
                  );
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = styles.navLink.color;
                  e.target.style.setProperty('--after-width', '0');
                }}
                className="nav-link"
              >
                Contact
                <style jsx>{`
                  .nav-link::after {
                    content: ${styles.navLinkAfter.content};
                    position: ${styles.navLinkAfter.position};
                    bottom: ${styles.navLinkAfter.bottom};
                    left: ${styles.navLinkAfter.left};
                    transform: ${styles.navLinkAfter.transform || 'none'};
                    width: var(--after-width, 0);
                    height: ${styles.navLinkAfter.height};
                    background-color: ${styles.navLinkAfter.backgroundColor};
                    transition: ${styles.navLinkAfter.transition};
                  }
                `}</style>
              </NavLink>
            </NavItem>

          </Nav>
        </Collapse>
      </Navbar>
    </header>
  );
};

export default Header;